import { Grid2, Checkbox, FormControlLabel } from "@mui/material";
import { getFormatedDate } from "../../../_helpers/dateTime.helper";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import EnumSelect from "../../../_components/autocomplete/enum.select";
import { TicketServeTypeEnum } from "../../../_common/enum/ticketServeType.enum";
import { accountService } from "../../../_services/accounts.service";

export function TicketServe({ data, setData, handleChange }: {
    data: any;
    setData: (_data: any) => void;
    handleChange: (event: any) => void;
}) {
    return (
        <>
            {(accountService.isAdmin || accountService.isUser) &&
                <Grid2 size={{ xs: 12 }}>
                    <StandardTextValidator
                        key="dueDate"
                        name="dueDate"
                        label="Due Date"
                        type="date"
                        fullWidth
                        required
                        validators={['required']}
                        errorMessages={['required field']}
                        value={data.dueDate != null ? getFormatedDate(data.dueDate) : ""}
                        onChange={handleChange}
                    />
                </Grid2>
            }
            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="lds"
                    name="lds"
                    label="LDS"
                    type="date"
                    fullWidth
                    required
                    validators={['required']}
                    errorMessages={['required field']}
                    value={data.lds != null ? getFormatedDate(data.lds) : ""}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <EnumSelect
                    key="serveTypeId"
                    enumObject={TicketServeTypeEnum}
                    label="Select Serve Type"
                    name="serveTypeId"
                    value={data.serveTypeId}
                    onChange={handleChange}
                    required
                    fullWidth
                />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!data.isRARequired}
                            onChange={(e) =>
                                setData((_data: any) => ({
                                    ..._data,
                                    isRARequired: e.target.checked
                                }))
                            }
                            name="isRARequired"
                        />
                    }
                    label="RA Required"
                />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!data.isOriginalDocument}
                            onChange={(e) =>
                                setData((_data: any) => ({
                                    ..._data,
                                    isOriginalDocument: e.target.checked
                                }))
                            }
                            name="isOriginalDocument"
                        />
                    }
                    label="Original Document"
                />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!data.isAffidavitRequired}
                            onChange={(e) =>
                                setData((_data: any) => ({
                                    ..._data,
                                    isAffidavitRequired: e.target.checked
                                }))
                            }
                            name="isAffidavitRequired"
                        />
                    }
                    label="Affidavit Required"
                />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="titleOfProceedings"
                    name="titleOfProceedings"
                    label="Title Of Proceedings (X vs Y)"
                    fullWidth
                    value={data.titleOfProceedings}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="other"
                    name="other"
                    label="Other"
                    fullWidth
                    value={data.other}
                    onChange={handleChange}
                />
            </Grid2>
        </>
    );
}
